/**
 * Mirror of the backend's `OptiselEventTags` object
 * (`optisel-business/.../optiselevent/OptiselEventTags.kt`).
 *
 * The backend ships these strings inside `OptiselEventJson.technicalTags`. Existing
 * values are persisted with historical events — never rename them, only add new ones.
 *
 * Reference these constants instead of inlining string literals when reading or
 * displaying tags on the frontend.
 */
export const OptiselEventTags = {
    WYMIARY_ZATWIERDZONE: "WYMIARY_ZATWIERDZONE",
    WYMIARY_NIEZATWIERDZONE: "WYMIARY_NIEZATWIERDZONE",
    BRAK_MECHANIKI: "BRAK_MECHANIKI",
} as const;
